<template>
    <div data-cy="choose-skin-item" class="skin-box d-flex justify-content-center" v-if="skin.id">
        <div
            :id="'skin-' + (skin.active? 'active':'store') + '-' + skin.id"
            class="skin-image position-relative d-flex justify-center align-center"
            @click="toggleActiveSkin"
        >
            <img
                :src="`https://assets.beeverso.org/skins/${getThumbnail(skin)}`"
                class="skin-img transition-all"
                @load="handleLoaded"
                alt="Sk"
            />
            <v-overlay absolute :value="!skin.active" opacity="0">
                <v-row class="absolute-beecoins" justify="center" align="center">
                    <v-img :src="require('@/assets/img/icons/beecoins.png')" height="50" width="50">
                    </v-img>
                </v-row>
            </v-overlay>
            <div
                class="pa-0 ma-0 skin-check skin-check-none white transition-all rounded-circle"
                :id="'skin-check-' + (skin.active? 'active':'store') + '-' + skin.id"
                >
                <em class="mdi mdi-36px mdi-checkbox-marked-circle purple-text transition-all pt-2"></em>
            </div>
            <v-skeleton-loader
                v-if="!loaded"
                class="border-radius-3 opacity-none"
                height="120"
                width="120"
                type="image"
                :transition="'scale-transition'"
            ></v-skeleton-loader>
        </div>
    </div>
</template>

<script>
const defaultSkin = () => {
    return {
        id: 0,
        skinPack: null,
        name: "",
        active: true,
        creationDate: "",
        resources: []
    }
}

export default {
    props: {
        skin: {
            type: Object,
            default: defaultSkin,
        },
        selected: { type: Boolean, default: false }
    },
    data() {
        return {
            loaded: false
        }
    },
    mounted() {
        if (this.selected) {
            this.setActiveSkin()
        }
        setTimeout(() => {
            this.setToBuy()
        }, 500)
    },
    methods: {
        getThumbnail(skin) {
            const img = skin.resources.find((res) => res.resourceUrl.includes('thumbnail'))
            return img.resourceUrl
        },
        setToBuy() {
            const skin = document.querySelector(`#skin-store-${this.skin.id} > img`)
            if (!this.skin.active && skin) {
                skin.classList.add('skin-to-buy')
            }
        },
        setActiveSkin() {
            const skin = document.querySelector(`#skin-active-${this.skin.id}`)
            skin.classList.add('skin-active')

            const check = document.querySelector(`#skin-check-active-${this.skin.id}`)
            check.classList.remove('skin-check-none')
        },
        deselectOthers () {
            const skin = document.querySelector('.skin-active')
            if (skin) {
                skin.classList.remove('skin-active')
            }

            const skinsCheck = document.querySelectorAll('.skin-check')
            if (skinsCheck.length > 0) {
                for (let i = 0; i < skinsCheck.length; i+=1) {
                    skinsCheck[i].classList.add('skin-check-none')
                }
            }
        },
        toggleActiveSkin() {
            if (!this.skin.active) {
                this.$emit('toBuy', this.skin)
                return
            }
            this.deselectOthers()

            const skin = this.skin.active ?
                document.querySelector(`#skin-active-${this.skin.id}`)
                : document.querySelector(`#skin-store-${this.skin.id}`)

            skin.classList.add('skin-active')

            const check = this.skin.active ?
                document.querySelector(`#skin-check-active-${this.skin.id}`)
                : document.querySelector(`#skin-check-store-${this.skin.id}`)

            check.classList.remove('skin-check-none')
            this.$emit('active', this.skin.id)
        },
        handleLoaded() {
            this.loaded = true
        },
    },
}
</script>

<style lang="css">
.skin-box,
.skin-image {
    border-radius: 25px;
}

.skin-active .skin-img {
    padding: 0;
}
.skin-img {
    display: block;
    width: 100%;
    border-radius: 17px;
}

.skin-active {
    border: 6px solid #7764CA;
    border-style: solid;
}
.purple-text{
  color: #6857B2;
  caret-color: #6857B2;
}
.skin-check {
    bottom: -20px;
    right: -15px;
    display: flex;
    position: absolute;
    justify-content: center;
    align-items: center;
}

.skin-check-none {
    display: none;
}
.skin-to-buy {
    opacity: 0.3;
}
.absolute-beecoins{
  bottom: -5em;
  right: -4em;
  position: absolute;
  @media screen and (max-width: 600px) {
    bottom: -4em;
    right: -3em;
  }
}
</style>
